import React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { IResponse } from './TemplateDataGovernance.types';
import { cpfMask } from "utils/cpf";
import { ptBR } from '@mui/x-data-grid/locales';
import { formatCNPJ } from "utils/is-valid-cnpj";

type Props = {
  data: IResponse['people'];
}

export function TemplateDataGovernanceTable({ data }: Props) {
  const formatPersonType = (type: "employee" | "dependent") => {
    return type === "employee" ? "Titular" : "Dependente";
  };

  const rows = data.map((person, index) => ({
    id: person.ID || `${index + 1}_${Date.now()}`,
    nomeCompleto: person.NAME || '-',
    cpfBeneficiario: person.TAX_PAYER_ID ? cpfMask(person.TAX_PAYER_ID) : '-',
    cpfTitular: person.EMPLOYEE_TAX_PAYER_ID ? cpfMask(person.EMPLOYEE_TAX_PAYER_ID) : '-',
    cnpjPj: person.LEGAL_ENTITY_TAX_ID ? formatCNPJ(person.LEGAL_ENTITY_TAX_ID, false) : '-',
    tipoBeneficiario: person?.PERSON_TYPE ? formatPersonType(person.PERSON_TYPE) : '-',
    camposVazios: person.missingData || '-',
    documentosFaltantes: '-',
    hiringEventDate: person.hiringEventDate ?? '-',
    hiringSentDate: person.hiringSentDate ?? '-',
    dismissalEventDate: person.dismissalEventDate ?? '-',
    dismissalSentDate: person.dismissalSentDate ?? '-',
    approvedPlan: person.approvedPlan ?? '-',
  }));

  const columns: GridColDef[] = [
    {
      field: 'nomeCompleto',
      headerName: 'Nome Completo',
      width: 300,
      sortable: true,
    },
    {
      field: 'cpfBeneficiario',
      headerName: 'CPF do Beneficiário',
      width: 160,
      sortable: true,
    },
    {
      field: 'cpfTitular',
      headerName: 'CPF do Titular',
      width: 160,
      sortable: true,
    },
    {
      field: 'cnpjPj',
      headerName: 'CNPJ do PJ',
      width: 160,
      sortable: true,
    },
    {
      field: 'tipoBeneficiario',
      headerName: 'Tipo do Beneficiário',
      width: 150,
      sortable: true,
    },
    {
      field: 'camposVazios',
      headerName: 'Campos Vazios',
      width: 200,
      sortable: true,
    },
    {
      field: 'documentosFaltantes',
      headerName: 'Documentos Faltantes',
      width: 180,
      sortable: true,
    },
    {
      field: 'approvedPlan',
      headerName: 'Plano Aprovado',
      width: 200,
      sortable: true,
    },
    {
      field: 'hiringEventDate',
      headerName: 'Data do Evento (Admissão)',
      width: 200,
      sortable: true,
    },
    {
      field: 'hiringSentDate',
      headerName: 'Envio ao eSocial (Admissão)',
      width: 220,
      sortable: true,
    },
    {
      field: 'dismissalEventDate',
      headerName: 'Data do Evento (Desligamento)',
      width: 220,
      sortable: true,
    },
    {
      field: 'dismissalSentDate',
      headerName: 'Envio ao eSocial (Desligamento)',
      width: 230,
      sortable: true,
    },
  ];

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 10 },
        },
      }}
      pageSizeOptions={[10, 25, 50]}
      disableRowSelectionOnClick
      localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
      style={{ backgroundColor: "white", minHeight: 400 }}
      sx={{
        '& .MuiDataGrid-cell': {
          fontSize: '0.875rem',
        },
        '& .MuiDataGrid-columnHeader': {
          fontSize: '0.875rem',
          fontWeight: 600,
        },
      }}
    />
  );
}
